<script setup lang="ts">
import WujieVue from 'wujie-vue2';
import { onUnmounted } from 'vue';
import { MICRO_NAME, MICRO_URL, UPDATE_BUTTON_VISIBLE_EVENT, UPDATE_HIGHLIGHT_ENABLED_EVENT } from './constants';
import { useChemicalEntry } from './composables/use-chemical-entry';
import { usePermission } from '@/composables/use-permission';

const { permissions } = usePermission();
const { getWujieProps, updateButtonVisible, updateHighlightEnabled } = useChemicalEntry();

const wujieProps = getWujieProps();

WujieVue.bus.$on(UPDATE_BUTTON_VISIBLE_EVENT, updateButtonVisible);
WujieVue.bus.$on(UPDATE_HIGHLIGHT_ENABLED_EVENT, updateHighlightEnabled);

onUnmounted(() => {
    WujieVue.bus.$off(UPDATE_BUTTON_VISIBLE_EVENT, updateButtonVisible);
    WujieVue.bus.$off(UPDATE_HIGHLIGHT_ENABLED_EVENT, updateHighlightEnabled);
});
</script>

<template>
    <WujieVue
        v-if="permissions.chemical"
        :name="MICRO_NAME"
        :url="MICRO_URL"
        :props="wujieProps"
    />
</template>
